const originalFetch = window.fetch;

window.fetch = async (url, options = {}) => {
    const headers = new Headers(options.headers || {});
    const raw = localStorage.getItem("token");
    const token = (!raw || raw === "null" || raw === "undefined") ? null : raw;

    // never overwrite a header the caller set explicitly
    if (token && !headers.has("Authorization")) {
        headers.set("Authorization", `Bearer ${token}`);
    }

    const response = await originalFetch(url, { ...options, headers });

    if (response.status === 401) {
        const authMessages = [
            "Please login first to continue",
            "Session expired, please log in again",
            "Invalid token",
            "Token has expired",
            // model service (flask_jwt_extended loaders in app_config.py)
            "Authorization token is required",
            "Invalid authorization token",
            "Authorization token has expired",
            "Authorization token has been revoked",
        ];

        // read from a clone so the caller can still parse the body
        let message = "";
        try {
            message = (await response.clone().json()).message || "";
        } catch { /* not JSON */ }

        if (authMessages.includes(message)) {
            localStorage.removeItem("token");
            localStorage.removeItem("email");
            localStorage.removeItem("userTokens");
            localStorage.removeItem("rbotUser");
            sessionStorage.clear();
            window.location.href = "/login";
        }
    }

    return response;
};